/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Install_New_VersionInputs */

const en_misc_install_new_version = /** @type {(inputs: Misc_Install_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install New Version`)
};

const es_misc_install_new_version = /** @type {(inputs: Misc_Install_New_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instalar nueva versión`)
};

/**
* | output |
* | --- |
* | "Install New Version" |
*
* @param {Misc_Install_New_VersionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const misc_install_new_version = /** @type {((inputs?: Misc_Install_New_VersionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Install_New_VersionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_misc_install_new_version(inputs)
	return en_misc_install_new_version(inputs)
});